import { render } from "./Footer.vue?vue&type=template&id=1c7bc4c5&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1c7bc4c5&scoped=true&lang=css"

import exportComponent from "D:\\Project\\Lmm\\gw_lmm\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_6285803b7cea55eb83ef6d11bd88d191\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7bc4c5"]])

export default __exports__